import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import participantIdsList from 'api/administration/participants/GetAllParticipants'

async function getIdsList(
  area: number[],
  searchText: string,
  usersFilter: string
) {
  return await participantIdsList(area, searchText, usersFilter)
}

function* participantIdsListEffectSaga(action: any) {
  try {
    const { area, searchText, usersFilter } = action.payload
    const { data } = yield call(getIdsList, area, searchText, usersFilter)
    yield put(fromActions.Actions.participantsIdsListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* participantIdsListWatcherSaga() {
  yield takeLatest(
    fromActions.PARTICIPANTS_IDS_LIST,
    participantIdsListEffectSaga
  )
}
